import { NavMenuConstants } from "constants/constants";
import { RootState } from "reducers/rootReducer";
import { Dispatch } from "redux";

export const toggleNavMenu = () => (dispatch: Dispatch, getStore: () => RootState) => {
  const { isOpen } = getStore()?.navMenuState;
  dispatch({
    type: NavMenuConstants.TOGGLE_NAV_MENU,
    payload: !isOpen,
  });
};
